import React from 'react';
import LogoProcessor from './LogoProcessor';

interface DefaultShowArtProps {
  size?: 'small' | 'large';
}

const DefaultShowArt: React.FC<DefaultShowArtProps> = ({ size = 'small' }) => {
  const sizeClasses = size === 'large' 
    ? 'w-full h-full' 
    : 'w-32 h-32 md:w-40 md:h-40';
    
  const logoSizeClasses = size === 'large'
    ? 'w-64 h-64'
    : 'w-24 h-24 md:w-32 md:h-32';
    
  return (
    <div className={`relative ${sizeClasses} rounded-lg overflow-hidden border-2 border-blue-900/30 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 group cursor-pointer transition-all hover:border-blue-600/50`}>
      {/* Starfield background */}
      <div className="absolute inset-0">
        <div className="absolute top-4 left-6 w-1 h-1 bg-white/20 rounded-full animate-pulse"></div>
        <div className="absolute top-8 right-8 w-0.5 h-0.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute bottom-12 left-12 w-0.5 h-0.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-16 right-4 w-1 h-1 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute bottom-6 right-10 w-0.5 h-0.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
      
      {/* Greyed out logo with glow on hover */}
      <div className="absolute inset-0 flex items-center justify-center opacity-30 group-hover:opacity-50 transition-opacity">
        <LogoProcessor
          src="/images/Across the Way.png" 
          alt="Across The Way" 
          className={`${logoSizeClasses} group-hover:filter group-hover:drop-shadow-[0_0_30px_rgba(96,165,250,0.8)] transition-all`}
        />
      </div>
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      
      {/* Subtle animation */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-600/5 via-transparent to-gray-600/5 animate-pulse"></div>
      
      {/* Glow effect on hover */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-radial from-blue-600/20 via-transparent to-transparent"></div>
    </div>
  );
};

export default DefaultShowArt;